import 'bootstrap/dist/css/bootstrap.min.css';
import NavBar from "./components/NavBar";
import './App.css';
import React, { useCallback, useState } from 'react'
import TopCard from './components/TopCard';
import { Card, Navbar } from 'react-bootstrap';
import * as PusherPushNotifications from "@pusher/push-notifications-web";

function App() {  
  const [ isLoggedIn, setLoggedIn ] = useState(false);
  let data = '';
  let token = '';
  let link = "";
  let variant = false;

  const dataUpdate = (dataFromPromise) => {
    data = dataFromPromise[1];
    token = dataFromPromise[0];
    localStorage.setItem('userToken', token)
    link = generateUrl(data.id);
    setLoggedIn(true);
  }

  const generateUrl = id => {
    return `${window.location.href + "msg/" + id}`
  }

  return (
   <div style={{ margin: 0, display: "flex", flexDirection: "column", justifyContent: "space-between", height: "100vh" }}>
   <div>
     <NavBar isLoggedIn={isLoggedIn} />
     <TopCard key={variant} link={link} dataUpdate={dataUpdate} setLoggedIn={setLoggedIn} /> 
     </div>
     <div style={{ background: "grey", color: "#fff", padding: "20px", textAlign: "center" }}>© Copyright Jermaine | All rights reserved. <br />Icon from flaticon.com</div>
     </div>
  );
}

export default App;
